import { forEach, cloneDeep, isArray } from 'lodash'
import { Message } from 'element-ui'

// 防抖
/* eslint-disable */
export function _debounce(fn, delay = 5000) {
  let timer
  return function () {
    const self = this
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(self, args)
    }, delay)
  }
}
// 节流
export function _throttle(fn, interval = 5000) {
  let last
  let timer
  return function () {
    const self = this
    const args = arguments
    const now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        last = now
        fn.apply(self, args)
      }, interval)
    } else {
      last = now
      fn.apply(self, args)
    }
  }
}

// 页面el-upload上传的图片转化为base64
export function _getBase64Image(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let imgResult = ''
    reader.readAsDataURL(file)
    reader.onload = () => {
      imgResult = reader.result
    }
    reader.onerror = (error) => {
      reject(error)
    }
    reader.onloadend = function () {
      resolve(imgResult)
    }
  })
}

//第一个参数就是原来的字符串，第二个是宽度，第三个就是回调方法
export function cutImageBase64(base64, w, callback, img) {
  var newImage = new Image()
  var quality = 0.6 //压缩系数0-1之间
  newImage.src = base64
  newImage.setAttribute('crossOrigin', 'Anonymous') //url为外域时需要
  var imgWidth, imgHeight
  newImage.onload = function () {
    imgWidth = this.width
    imgHeight = this.height
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w
        canvas.height = (w * imgHeight) / imgWidth
      } else {
        canvas.height = w
        canvas.width = (w * imgWidth) / imgHeight
      }
    } else {
      canvas.width = imgWidth
      canvas.height = imgHeight
      quality = 0.6
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
    var base64 = canvas.toDataURL('image/jpeg', quality) //压缩语句
    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    while (base64.length / 1024 > 150) {
      quality -= 0.01
      base64 = canvas.toDataURL('image/jpeg', quality)
    }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    while (base64.length / 1024 < 50) {
      quality += 0.001
      base64 = canvas.toDataURL('image/jpeg', quality)
    }
    callback(base64, img) //必须通过回调函数返回，否则无法及时拿到该值
  }
}
export function transformUnits(limit) {
  let size = ''
  if (limit < 0.1 * 1024) {
    // 小于0.1KB，则转化成B
    size = `${limit.toFixed(2)}B`
  } else if (limit < 0.1 * 1024 * 1024) {
    // 小于0.1MB，则转化成KB
    size = `${(limit / 1024).toFixed(2)}KB`
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    // 小于0.1GB，则转化成MB
    size = `${(limit / (1024 * 1024)).toFixed(2)}MB`
  } else {
    // 其他转化成GB
    size = `${(limit / (1024 * 1024 * 1024)).toFixed(2)}GB`
  }

  const sizeStr = `${size}` // 转成字符串
  const index = sizeStr.indexOf('.') // 获取小数点处的索引
  const dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
  if (dou === '00') {
    // 判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return size
}


// 数组转一维数组
export function treeToOneArray(treeData, key) {
  const flattenList = []
  forEach(treeData, (item) => {
    const cloneItem = cloneDeep(item)
    delete cloneItem[key]
    flattenList.push(cloneItem)
    if (isArray(item[key])) {
      const flattenChildren = treeToOneArray(item[key], key)
      flattenList.push(...flattenChildren)
    }
  })
  return flattenList
}

// 生成guid
export const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}

export function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      Message.success('复制成功');
    }).catch(err => {
      Message.success('复制失败');
      console.error('Could not copy text: ', err);
    })
  } else {
    fallbackCopyToClipboard(text);
  }
}

function fallbackCopyToClipboard(text) {
  try {
    // 创建一个文本输入元素
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // 将文本区域添加到DOM中
    document.body.appendChild(textArea);

    // 选择文本区域的内容
    textArea.select();
    textArea.setSelectionRange(0, 99999); // 对于移动设备

    // 执行复制命令
    document.execCommand("copy");

    // 移除文本区域
    document.body.removeChild(textArea);
    Message.success('复制成功');
  } catch (error) {
    console.error('Could not copy text: ', error);
  }
}